import { router } from "@inertiajs/vue3";
import { useFetch } from "~vue/api";
import { CHATSOURCE } from "~vue/utils/constants.js";
import { logError, logUserInteraction } from "~vue/utils/logUtils";
import { ref } from "vue";

const CONNECTION_CHAT_MESSAGE_TEMPLATE = (personName) => `Hey Nadia, can we talk about ${personName || "this person"}?`;

export const useConnectionActions = () => {
    const getChatMessage = (personName) => {
        return CONNECTION_CHAT_MESSAGE_TEMPLATE(personName);
    };

    const startChatPayload = ref(null);
    const { data: startChatResponse, execute: executeStartChat, error: startChatError } = useFetch("/coach/start/", { immediate: false }).post(startChatPayload).json();

    const startChat = async (connection, options = {}) => {
        const { message = getChatMessage(connection.persona?.name), chatSource = CHATSOURCE.CONNECTION_DETAIL, files = [], logSource = "text" } = options;

        logUserInteraction("connection_chat_started", {
            source: logSource,
            connection_id: connection.id,
        });

        startChatPayload.value = {
            chat_source: chatSource,
            connection_id: connection.id,
            initial_message: message,
            initial_message_files: files,
        };

        await executeStartChat();

        if (startChatError.value) {
            throw startChatError.value;
        }

        return startChatResponse.value?.redirect_url;
    };

    const startRolePlay = (connection, rolePlaySetupUrl = "/role-play/setup/") => {
        logUserInteraction("connection_role_play_button_clicked", {
            id: connection.persona?.id,
        });

        router.get(
            rolePlaySetupUrl,
            { persona: JSON.stringify(connection.persona) },
            {
                headers: {
                    "Content-Type": "application/json",
                },
                onError: (error) => {
                    logError("Failed to start role play:", error);
                },
            },
        );
    };

    const viewDetails = (connectionId) => {
        logUserInteraction("connection_detail_clicked", {
            connection_id: connectionId,
        });

        router.get(`/people/${connectionId}/`);
    };

    return {
        getChatMessage,
        startChat,
        startChatError,
        startRolePlay,
        viewDetails,
    };
};
